import { ReactElement, useEffect, useState } from "react";
import { IChartWrapperProps } from "../../types";
import { IHeatMapChartConfig } from "../../../../components/charts/types";
import HeatMapChart from "../../../../components/charts/heatMapChart";
import { getGenericChartConfig } from "./utils";

const HeatMapChartWrapper = ({ cell, data, parentSize, palette, updatePalette, node, schemas }: IChartWrapperProps): ReactElement => {
  const [ chartConfig, setChartConfig ] = useState<IHeatMapChartConfig | null>(null);

  useEffect(() => {
    if (data) {
      const [ series, xAxis ] = getGenericChartConfig(data, cell, node, palette, updatePalette, schemas);

      setChartConfig({
        // width: 300,
        height: parentSize.height,
        series,
        xAxis,
        showLegend: true
      });
    }
  }, [ cell, data, parentSize, palette, updatePalette, node, schemas ]);


  return (
    <div style={{ ...parentSize }}>
      {chartConfig && <HeatMapChart chartConfig={chartConfig}/>}
    </div>
  );
};

export default HeatMapChartWrapper;
